import { lazy } from "react";

export const ComponentMap = {
  C101Hero: lazy(() =>
    import("../../cms-components/C101Hero/C101Hero").then((module) => ({
      default: module.C101Hero,
    })),
  ),
  C103TextBlock: lazy(() =>
    import("../../cms-components/C103TextBlock/C103TextBlock").then(
      (module) => ({ default: module.C103TextBlock }),
    ),
  ),
  C104WorkshopProgram: lazy(() =>
    import("../../cms-components/C104WorkshopProgram/C104WorkshopProgram").then(
      (module) => ({ default: module.C104WorkshopProgram }),
    ),
  ),
  C105NotesCarousel: lazy(() =>
    import("../../cms-components/C105NotesCarousel/C105NotesCarousel").then(
      (module) => ({ default: module.C105NotesCarousel }),
    ),
  ),
  C106Instructors: lazy(() =>
    import("../../cms-components/C106Instructors/C106Instructors").then(
      (module) => ({ default: module.C106Instructors }),
    ),
  ),
  C107Challenge: lazy(() =>
    import("../../cms-components/C107Challenge/C107Challenge").then(
      (module) => ({ default: module.C107Challenge }),
    ),
  ),
  C108ApplicationTerms: lazy(() =>
    import(
      "../../cms-components/C108ApplicationTerms/C108ApplicationTerms"
    ).then((module) => ({ default: module.C108ApplicationTerms })),
  ),
  C109Timeline: lazy(() =>
    import("../../cms-components/C109Timeline/C109Timeline").then((module) => ({
      default: module.C109Timeline,
    })),
  ),
  C110CallToAction: lazy(() =>
    import("../../cms-components/C110CallToAction/C110CallToAction").then(
      (module) => ({ default: module.C110CallToAction }),
    ),
  ),
  C111Faq: lazy(() =>
    import("../../cms-components/C111Faq/C111Faq").then((module) => ({
      default: module.C111Faq,
    })),
  ),
  C112RichText: lazy(() =>
    import("../../cms-components/C112RichText/C112RichText").then((module) => ({
      default: module.C112RichText,
    })),
  ),
  C113Winners: lazy(() =>
    import("../../cms-components/C113Winners/C113Winners").then((module) => ({
      default: module.C113Winners,
    })),
  ),
} as const;

export type ComponentMapType = typeof ComponentMap;
